import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import TermsModal from "./TermsModal";
import { TERMS_VERSION } from "./TermsContent";

/** An artist or fan account that has not accepted the current Terms of Use (they changed, or
 * the account was created from an old app) must accept them to go on; refusing logs out. */
export default function TermsGate() {
  const { user, acceptTerms, logout } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!user || !["artist", "viewer"].includes(user.role) || user.terms_version === TERMS_VERSION) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await acceptTerms();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Réessaie dans un instant.");
    } finally {
      setBusy(false);
    }
  };
  const refuse = () => {
    logout();
    navigate("/auth");
    toast("Tu as été déconnecté : il faut accepter les conditions d'utilisation pour utiliser Metazik.", { duration: 7000 });
  };

  return (
    <TermsModal
      intro={user.terms_version
        ? "Nos conditions ont été mises à jour. Lis-les et accepte-les pour continuer."
        : "Lis les conditions d'utilisation et accepte-les pour continuer à utiliser Metazik."}
      refuseLabel="Je refuse (déconnexion)"
      busy={busy}
      onAccept={accept}
      onRefuse={refuse}
    />
  );
}
